import {
  InputGroup,
  Input,
  InputRightElement,
  Icon,
  HStack,
  StackDivider,
  InputProps,
} from '@chakra-ui/react';
import { IoSearchOutline, IoCloseCircle } from 'react-icons/io5';

type SearchInputProps = {
  onSearch: () => void;
  onClear: () => void;
} & InputProps;

export default function SearchInput({ onSearch, onClear, ...props }: SearchInputProps) {
  return (
    <InputGroup maxW="800px" size="lg">
      <Input
        border="none"
        borderRadius="10px"
        bgColor="white"
        _focus={{}}
        boxShadow="0px 0px 10px rgba(0, 0, 0, 0.1)"
        placeholder="搜尋餐廳 / 餐點"
        _placeholder={{
          color: 'gray.500',
        }}
        {...props}
      />
      <InputRightElement w="5.5rem">
        <HStack justify="flex-end" divider={<StackDivider />}>
          <Icon
            as={IoCloseCircle}
            boxSize="1.5rem"
            color={props.value ? 'gray.500' : 'transparent'}
            onClick={() => props.value && onClear()}
          />

          <Icon as={IoSearchOutline} color="primary" boxSize="1.5rem" onClick={onSearch} />
        </HStack>
      </InputRightElement>
    </InputGroup>
  );
}
